<template>
  <div
    class="text-right"
    data-qa="doctor_service_prices_update_info_wrapper"
  >
    <div
      data-qa="doctor_service_prices_update_info"
      class="doctor-service-prices-update-info text-caption"
      :class="{ [componentClasses]: text }"
    >
      <template v-if="text">
        {{ text }}
      </template>
    </div>
  </div>
</template>

<script>
import i18next from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'
import { STATUS_TYPES } from 'www/vue_components/common/DoctorServicePrices/components/UpdateInfo/constants'

export default {
  name: 'UpdateInfo',
  props: {
    status: {
      type: Number,
      default: null,
    },
    dateString: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    userLanguage: getUserLanguage(),
  }),
  computed: {
    statuses() {
      return {
        isSuccess: this.status === STATUS_TYPES.success,
        isWarning: this.status === STATUS_TYPES.warning,
        isError: this.status === STATUS_TYPES.error,
      }
    },
    componentClasses() {
      if (this.statuses.isSuccess) {
        return 'bg-success success--text'
      }

      if (this.statuses.isWarning) {
        return 'bg-warning warning--text'
      }

      if (this.statuses.isError) {
        return 'bg-error error--text'
      }

      return ''
    },
    text() {
      if (!this.dateString) {
        return ''
      }

      const baseText = `${i18next.t('Обновлено клиникой', { ns: this.userLanguage })} ${this.dateString}`

      if (this.statuses.isSuccess) {
        return baseText
      }

      if (this.statuses.isWarning) {
        return `${baseText}. ${i18next.t('Цены могли устареть', { ns: this.userLanguage })}`
      }

      if (this.statuses.isError) {
        return `${baseText}. ${i18next.t('Цены устарели', { ns: this.userLanguage })}`
      }

      return ''
    },
  },
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';

.doctor-service-prices-update-info {
  display: inline-block;
  border-radius: $border-radius-sm;
  padding: 4px 8px;

  // Хак, чтобы высота элемента не менялась при отсутствии текста
  &:empty::before {
    content: '\00A0';
  }
}
</style>
